import AnimatedSection from "../ui/AnimatedSection";
import { siteConfig } from "../../data/portfolioData";

export default function ContactSection() {
  return (
    <section id="contact" className="py-24 lg:py-32 bg-carbon-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <AnimatedSection className="mb-16">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-8 h-px bg-ember-400" />
            <span className="font-mono text-xs text-ember-400 tracking-widest uppercase">
              Let's Work Together
            </span>
          </div>
          <h2 className="font-display text-[clamp(3rem,7vw,6rem)] leading-none tracking-wider text-ash-100">
            CONTACT
          </h2>
        </AnimatedSection>

        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">

          {/* Left — headline */}
          <AnimatedSection delay={100}>
            <p className="font-body text-ash-400 text-lg leading-relaxed mb-10">
              Whether you have a full brief or just a rough idea. I'm here for it.
              Let's talk about your project and create something worth watching.
            </p>

            {/* Social links */}
            <div>
              <p className="font-mono text-xs text-ash-600 tracking-widest uppercase mb-4">
                Find me on
              </p>
              <div className="flex flex-wrap gap-3">
                {Object.entries(siteConfig.socialLinks).map(([platform, url]) => (
                  <a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-mono text-xs text-ash-400 border border-carbon-700 px-4 py-2 uppercase tracking-widest hover:border-ember-400 hover:text-ember-400 transition-all duration-300"
                  >
                    {platform}
                  </a>
                ))}
              </div>
            </div>
          </AnimatedSection>

          {/* Right — contact details */}
          <AnimatedSection delay={200}>
            <div className="space-y-4">

              {/* Email */}
              <a
                href={`https://mail.google.com/mail/?view=cm&to=${siteConfig.email}&su=Portfolio Inquiry`}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-5 p-6 border border-carbon-800 hover:border-ember-400/50 bg-carbon-950 hover:bg-carbon-800 transition-all duration-300"
              >
                <div className="w-12 h-12 border border-carbon-700 group-hover:border-ember-400 flex items-center justify-center flex-shrink-0 transition-all duration-300">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#ff6b35" strokeWidth="1.5">
                    <rect x="1" y="3" width="14" height="10" rx="1" />
                    <path d="M1 4l7 6 7-6" />
                  </svg>
                </div>
                <div>
                  <p className="font-mono text-xs text-ash-600 tracking-widest uppercase mb-1">Email</p>
                  <p className="font-body text-ash-100 group-hover:text-ember-400 transition-colors duration-300">
                    {siteConfig.email}
                  </p>
                </div>
                <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#ff6b35" strokeWidth="1.5">
                    <path d="M2 12L12 2M12 2H5M12 2v7" />
                  </svg>
                </div>
              </a>

              {/* Phone */}
              <a
                href={`tel:${siteConfig.phone}`}
                className="group flex items-center gap-5 p-6 border border-carbon-800 hover:border-ember-400/50 bg-carbon-950 hover:bg-carbon-800 transition-all duration-300"
              >
                <div className="w-12 h-12 border border-carbon-700 group-hover:border-ember-400 flex items-center justify-center flex-shrink-0 transition-all duration-300">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#ff6b35" strokeWidth="1.5">
                    <path d="M3 1h3l1.5 4-2 1.5c1 2 2.5 3.5 4.5 4.5L11.5 9 15 10.5V14c0 .5-.5 1-1 1C5 15 1 8 1 3c0-.5.5-1 1-1z" />
                  </svg>
                </div>
                <div>
                  <p className="font-mono text-xs text-ash-600 tracking-widest uppercase mb-1">Phone</p>
                  <p className="font-body text-ash-100 group-hover:text-ember-400 transition-colors duration-300">
                    {siteConfig.phone}
                  </p>
                </div>
                <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#ff6b35" strokeWidth="1.5">
                    <path d="M2 12L12 2M12 2H5M12 2v7" />
                  </svg>
                </div>
              </a>

              {/* Location */}
              <div className="flex items-center gap-5 p-6 border border-carbon-800 bg-carbon-950">
                <div className="w-12 h-12 border border-carbon-700 flex items-center justify-center flex-shrink-0">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#ff6b35" strokeWidth="1.5">
                    <path d="M8 1C5.24 1 3 3.24 3 6c0 4.25 5 9 5 9s5-4.75 5-9c0-2.76-2.24-5-5-5z" />
                    <circle cx="8" cy="6" r="1.5" />
                  </svg>
                </div>
                <div>
                  <p className="font-mono text-xs text-ash-600 tracking-widest uppercase mb-1">Location</p>
                  <p className="font-body text-ash-100">{siteConfig.location}</p>
                </div>
              </div>

            </div>
          </AnimatedSection>

        </div>
      </div >
    </section >
  );
}